export enum ButtonSize {
  normal,
  large,
  small,
}

export function parseButtonSize(value: string): ButtonSize {
  if (value === 'large') {
    return ButtonSize.large;
  } else if (value === 'small') {
    return ButtonSize.small;
  }
  return ButtonSize.normal;
}
